import classnames from 'classnames';
import { elementType, func, node, object, string } from 'prop-types';

import ChevronLeftButton from '~/components/ButtonIcons/ChevronLeftButton';

import SharePopup from './SharePopup';

import styles from './NavigationBar.module.scss';

const NavigationBar = ({
  path,
  onClose,
  children,
  itemName,
  item,
  Button,
  buttonsClassname,
  shareButtonClassName,
  className,
}) => (
  <div className={classnames(styles.navigationBar, className)}>
    <Button
      className={classnames(buttonsClassname, styles.navigationBarBackButton)}
      onClick={onClose}
      path={path}
    />
    {children}
    <SharePopup
      item={item}
      itemName={itemName}
      className={classnames(buttonsClassname, shareButtonClassName)}
    />
  </div>
);

export const propTypes = {
  path: string,
  onClose: func,
  children: node,
  itemName: string,
  item: object,
  Button: elementType,
  buttonsClassname: string,
  shareButtonClassName: string,
  className: string,
};

NavigationBar.propTypes = propTypes;

NavigationBar.defaultProps = {
  Button: ChevronLeftButton,
};

export default NavigationBar;
